import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import providesOrganizationResourcesUsage from 'components/Organizations/dataSync/providesResourcesUsage'

import { selectors as OrganizationResourcesUsageSelectors } from 'data/organizationResourcesUsage'

import Dropdown from 'components/base/Dropdown'
import ProgressBar from 'components/Utils/ProgressBar'

function OrganizationResourcesUsageItem(props) {
  const { noteResourcesUsage, title, action } = props
  const { current, limit } = noteResourcesUsage
  const hasLoaded = Boolean(current && limit)
  const percentage = Math.min((current / limit) * 100, 100)

  return (
    <Dropdown.Item onClick={action}>
      {hasLoaded && (
        <React.Fragment>
          <div>
            <span className="font-weight-medium font-size-large">
              {current}
            </span>
            <span>/{limit}</span>
            <span> {title}</span>
          </div>
          <ProgressBar
            max="100"
            value={percentage}
            className="margin-vertical-small"
          />
        </React.Fragment>
      )}
      <div className="font-weight-regular font-size-smaller line-height-large">
        Under free plan you can create 50 shared notes over a 30-day period.{' '}
      </div>
    </Dropdown.Item>
  )
}

const enhance = compose(
  providesOrganizationResourcesUsage,
  connect(state => {
    return {
      noteResourcesUsage: OrganizationResourcesUsageSelectors.getNoteResourcesUsage(
        state
      ),
    }
  })
)

export default enhance(OrganizationResourcesUsageItem)
